import React, { useEffect, useState } from 'react';
import { UserConsigneeApplicationService } from 'services';
import { CONSIGNEE_APPLICATION_STATUS } from 'helpers/constants';
import { useIsUser, useStore } from 'hooks';
import Menu from 'components/menu';
import Table from 'components/table';
import Actions from 'components/table/actions';
import Modal from 'components/modal';
import ConsigneeApplications from 'components/modal/consignee-applications';
import styles from './consignee-applications.module.scss';

const ConsigneeApplicationsPage = () => {
  const { reload, setUser, setLoading, setReload } = useStore();
  const [edit, setEdit] = useState(null);
  const [modal, setModal] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    (async () => {
      setLoading(true);

      const consigneeResponse = await new UserConsigneeApplicationService({ setUser })
        .getConsigneeApplications();

      if (consigneeResponse) {
        setData(consigneeResponse);
      }

      setLoading(false);
    })();
  }, [reload, setUser, setLoading]);

  const isUser = useIsUser();

  const onOpenModal = () => setModal(true);

  const onCloseModal = (isReload = false) => {
    setEdit(null);
    setModal(false);
    if (isReload) {
      setReload();
    }
  };

  const onDelete = async ({ id }) => {
    await new UserConsigneeApplicationService({ setUser }).deleteConsigneeApplication(id);
    setReload();
  };

  const cells = [{
    name: 'Грузополучатель',
    renderField: 'name',
  }, {
    name: 'Адрес грузо-ля',
    renderField: 'address',
  }, {
    name: 'ЖД код грузо-ля',
    renderField: 'codeGd',
  }, {
    name: 'Статус',
    renderField: 'status',
    onRender: (item, value) => CONSIGNEE_APPLICATION_STATUS.toString(value),
  }, {
    name: '',
    right: true,
    nowrap: true,
    onRender: item => (
      <Actions
        data={[{
          name: 'edit',
          onClick: () => {
            setEdit(item);
            setModal(true);
          },
        }, {
          name: 'cart',
          onClick: () => onDelete(item),
        }]}
      />
    ),
  }];

  return (
    <>
      <div className={styles.menu}>
        {isUser ? (
          <Menu onAdd={onOpenModal} />
        ) : (
          <Menu />
        )}
      </div>
      <div className={styles.table}>
        <Table cells={cells} data={data} />
      </div>
      {modal ? (
        <Modal closeBackground={false} onClose={onCloseModal}>
          <ConsigneeApplications edit={edit} onClose={onCloseModal} />
        </Modal>
      ) : null}
    </>
  );
};

export default ConsigneeApplicationsPage;
